import { Box, CircularProgress } from '@material-ui/core';
import { DefaultCard } from 'design-system';

export const LoadingEquifaxContent = (): JSX.Element => {
  return (
    <Box sx={{ textAlign: 'center', py: '2rem' }}>
      <CircularProgress />
      <br />
      Espere unos segundos...
    </Box>
  );
};

export const LoadingEquifax = (): JSX.Element => {
  return (
    <DefaultCard
      width="100%"
      cardStyles={{
        margin: '0 auto',
      }}
    >
      <LoadingEquifaxContent />
    </DefaultCard>
  );
};
